import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { ProfileService } from '../../core/services/profile.service';
import { AuthService } from '../../core/services/auth.service';
import { UtilityService } from '../../core/services/utility.service';
import { EventsService } from '../../core/services/events.service'
import { EventBasicInfo } from '../../core/models/event-basic-info';
import { Router } from '@angular/router';
import { Constants } from '../../core/config/Constants';
import { firebase } from '@firebase/app';
import { ExtraService } from '../../core/services/extra.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { setTimeout } from 'timers';
import { AngularFireObject, AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { MenuTypeService } from '../../core/services/menu-type.service';
import { ContentsMandatory } from '../../core/models/contents-mandatory';
import { Content } from '../../core/models/content';
import { Speaker } from '../../core/models/speaker';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css'],
  providers: [UtilityService, ProfileService, EventsService, ExtraService, MenuTypeService]
})

export class WelcomeComponent implements OnInit {

  name: string;
  message: string = null;
  eventIdList: Array<string> = new Array();
  eventList: Array<EventBasicInfo> = new Array();

  constructor(
    private db: AngularFireDatabase, 
    private menuTypyService: MenuTypeService, 
    private confirmationService: ConfirmationService, 
    private extraService: ExtraService, 
    private utilityService: UtilityService, 
    private profileService: ProfileService, 
    private eventsService: EventsService, 
    private router: Router
  ) {
    this.setUserName();
    this.setEventList();
  }
  ngOnInit() {
    this.extraService.changeSideBar(false);
    this.extraService.changeStateofSideBarButton(false);
  }
  ngOnDestroy() {
    this.extraService.setCurrentEventId(null);
  }
  setUserName() {
    this.profileService.getUserProfile().subscribe(item => {
      if (item) {
        this.name = item.name;
      }
    });
  }

  setEventList() {
    this.eventsService.getEventList().snapshotChanges().subscribe(list => {
      this.eventIdList = new Array();
      this.eventList = new Array();
      list.forEach(element => {
        var y = element.payload.toJSON();
        this.eventsService.getEventBasicInfo(y).subscribe(event => {
          if (event && this.eventIdList.indexOf(y + "") == -1) {
            this.eventIdList.push(y + "");
            event.show = true;
            this.eventList.push(event);
            console.log(this.eventList);
          }
        });
      });
    });
    this.eventsService.getSharedEventList().snapshotChanges().subscribe(list => {
      console.log("Shared Event List:", list)
      list.forEach(element => {
        var y = element.payload.toJSON();
        this.eventsService.getEventBasicInfo(y).subscribe(event => {
          if (event && this.eventIdList.indexOf(y + "") == -1) {
            this.eventIdList.push(y + "");
            event.show = true;
            this.eventList.push(event);
            console.log(this.eventList);
          }
        });
      });
    });
  }

  deleteEvent(event: EventBasicInfo) {

    let index = this.eventIdList.indexOf(event.eventId);

    //this function delete all menu-type files from storage
    this.getEventMenuType(event.eventId).subscribe(cm => {
      if (cm) {
        for (let key in cm) {
          //console.log(cm[key].category, cm[key].filename)
          if (cm[key].category == Constants.CONTENT_M_TYPE_LOGO) {
            let storageReff = firebase.storage().ref();
            storageReff.child(`${"/" + event.eventId + Constants.Contents_Mandatory_URL + "/" + cm[key].category}/${cm[key].filename}`).delete();
          } else if (cm[key].category == Constants.CONTENT_M_TYPE_BG) {
            let storageReff = firebase.storage().ref();
            storageReff.child(`${"/" + event.eventId + Constants.Contents_Mandatory_URL + "/" + cm[key].category}/${cm[key].filename}`).delete();
          } else if (cm[key].category == Constants.CONTENT_M_TYPE_MENU) {
            let storageReff = firebase.storage().ref();
            storageReff.child(`${"/" + event.eventId + Constants.Contents_Mandatory_URL + "/" + cm[key].category}/${cm[key].filename}`).delete();
          } else if (cm[key].category == Constants.CONTENT_M_TYPE_SESSION) {
            let storageReff = firebase.storage().ref();
            storageReff.child(`${"/" + event.eventId + Constants.Contents_Mandatory_URL + "/" + cm[key].category}/${cm[key].filename}`).delete();
          } else if (cm[key].category == Constants.CONTENT_M_TYPE_SPLASH) {
            let storageReff = firebase.storage().ref();
            storageReff.child(`${"/" + event.eventId + Constants.Contents_Mandatory_URL + "/" + cm[key].category}/${cm[key].filename}`).delete();
          } else if (cm[key].category == Constants.CONTENT_M_TYPE_ABOUT) {
            let storageReff = firebase.storage().ref();
            storageReff.child(`${"/" + event.eventId + Constants.Contents_Mandatory_URL + "/" + cm[key].category}/${cm[key].filename}`).delete();
          } else if (cm[key].category == Constants.CONTENT_M_TYPE_SPONSORS) {
            let storageReff = firebase.storage().ref();
            // let logoIconName = cm[key].filename.split(" ").join("");
            let logoIconName = cm[key].filename;
            storageReff.child(`${"/" + event.eventId + Constants.Contents_Mandatory_URL + "/" + cm[key].category}/${logoIconName}`).delete();
          } else if (cm[key].category == Constants.CONTENT_M_TYPE_VENUE) {
            let storageReff = firebase.storage().ref();
            storageReff.child(`${"/" + event.eventId + Constants.Contents_Mandatory_URL + "/" + Constants.STORAGE_VENUE_URL}/${cm[key].filename}`).delete();
          } else if (cm[key].category == Constants.CONTENT_M_TYPE_SPEAKERS) {
            let storageReff = firebase.storage().ref();
            storageReff.child(`${"/" + event.eventId + Constants.Contents_Mandatory_URL + "/" + cm[key].category}/${cm[key].filename}`).delete();
          }
        } //for loop end
      }//event end

      //this function delete all Content Files from storage
      this.getEventContent(event.eventId).subscribe(content => {
        if (content) {
          for (let key in content) {
            let storageRef = firebase.storage().ref();
            storageRef.child(`${event.eventId + Constants.CONTENT_M_TYPE_CONTENTS}/${content[key].name}`).delete();
          }
        }
        this.eventsService.deleteEvent(event, index).then(res => {
          this.message = "Event Deleted Successfully";
        }).catch(error => {
          console.log(error.message);
        });

      });
    });


    this.eventIdList = this.eventIdList.filter((val, i) => i != this.eventIdList.indexOf(event.eventId));
    this.eventsService.removeEventToEventList(this.eventIdList);

    setTimeout(() => {
      this.message = null;
      this.setEventList();
    }, 3000);

  }

  editEvent(event: EventBasicInfo) {
    this.router.navigate([Constants.INFO_URL], { queryParams: { eventId: event.eventId } });
  }

  newEvent() {
    this.router.navigate([Constants.INFO_URL]);
  }

  confirmDelete(event: EventBasicInfo) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete Event: ' + event.name + '?',
      accept: () => {
        this.deleteEvent(event);
      }
    });
  }

  getEventMenuType(eventId): Observable<ContentsMandatory> {
    if (this.utilityService.isLogged()) {
      let data: AngularFireObject<ContentsMandatory> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.Contents_Mandatory_URL);
      return data.valueChanges();
    }
    return null;
  }

  getEventContent(eventId): Observable<Content> {
    if (this.utilityService.isLogged()) {
      let data: AngularFireObject<Content> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.CONTENT_URL);
      return data.valueChanges();
    }
    return null;
  }

  getSpeakerData(eventId): Observable<Speaker> {
    if (this.utilityService.isLogged()) {
      let data: AngularFireObject<Speaker> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.SPEAKER_URL);
      return data.valueChanges();
    }
    return null;
  }

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/event/welcome/welcome.component.ts